module.exports = __webpack_public_path__ + "svg/roulette-zero-choosen.svg?6be2b38911fd0c7ab2cbdb0ff427c187";